import {React} from 'react';

const HelpSupport = () => {
    return (
        <div className='flex flex-col font-inter my-2 md:my-0'>
            <p className='font-semibold text-lg text-black'>Help & Support</p>

            <nav className='flex flex-col w-fit pt-3 md:pt-6'>
                <ul className='flex flex-col gap-y-2 text-sm md:text-md md:gap-y-3'>
                    <li><a href='#' className='text-blue-400 font-light hover:underline'>Help Center</a></li>
                    <li><a href='#' className='text-blue-400 font-light hover:underline'>User Agreement</a></li>
                    <li><a href='#' className='text-blue-400 font-light hover:underline'>Terms & Conditions</a></li>
                    <li><a href='#' className='text-blue-400 font-light hover:underline'>Privacy Policy</a></li>
                    <li><a href='#' className='text-blue-400 font-light hover:underline'>Payment Policy</a></li>
                    <li><a href='#' className='text-blue-400 font-light hover:underline'>Return & Refunds Policy</a></li>
                    <li><a href='#' className='text-blue-400 font-light hover:underline'>Community Guidelines</a></li>
                </ul>

            </nav>

        </div>
    )
}

export default HelpSupport